import { IAPIUrlViewModel, RequestDTO } from '@/types/aspiSync';
import request from '../base-service';
import type { InternalAxiosRequestConfig } from 'axios';

const baseUrl = '/v1';
const baseApiUrl = `${baseUrl}/apiurl`;
const baseApiSync = `${baseUrl}/apisync`;
const baseApiUrlParam = `${baseUrl}/apiurlparam`;
const baseApiLicense = `/v1/license`;

export const apiUrlApi = {
    pager: (requestDTO: RequestDTO) =>
        request.post(`${baseApiUrl}/pager`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),
    list: (requestDTO: RequestDTO) =>
        request.post(`${baseApiUrl}/list`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),
    deleteParam: (id: string | number) =>
        request.delete(`${baseApiUrlParam}/${id}`, { authorization: true } as InternalAxiosRequestConfig),
    // data có thể là { apiUrl, detailData } hoặc { request: { apiUrl, detailData } }
    create: (data: any) =>
        request.post(`${baseApiSync}/create`, data, { authorization: true } as InternalAxiosRequestConfig),
    update: (data: any) =>
        request.post(`${baseApiSync}/update`, data, { authorization: true } as InternalAxiosRequestConfig),
    delete: (id: string | number) =>
        request.delete(`${baseApiSync}/${id}`, { authorization: true } as InternalAxiosRequestConfig),
    find: (id: string | number) =>
        request.get(`${baseApiSync}/detail/${id}`, { authorization: true } as InternalAxiosRequestConfig),
    branch: (requestDTO: RequestDTO) =>
        request.post<IAPIUrlViewModel[]>(`${baseApiSync}/branch`, requestDTO, {
            authorization: true,
        } as InternalAxiosRequestConfig),
    call: (data: IAPIUrlViewModel) =>
        request.post(`${baseApiSync}/call`, data, { authorization: true } as InternalAxiosRequestConfig),
    getLicense: (init: string = '0') =>
        request.get(`${baseApiLicense}/getlicense?init=${init}`, { authorization: true } as InternalAxiosRequestConfig),
    updateLicense: (data: any) =>
        request.post(`${baseApiLicense}/update`, data, { authorization: true } as InternalAxiosRequestConfig),
};

const baseApiMapBaoCao = '/v1/apimapbaocao';

export const apiMapBaoCaoApi = {
    getListApi: (data: { site?: string; systemID: string; module: string }) =>
        request.post(`${baseApiMapBaoCao}/list-api`, data, { authorization: true } as InternalAxiosRequestConfig),
    save: (data: any) =>
        request.post(`${baseApiMapBaoCao}/save`, data, { authorization: true } as InternalAxiosRequestConfig),
    test: (data: any) =>
        request.post(`${baseApiMapBaoCao}/test`, data, { authorization: true } as InternalAxiosRequestConfig),
    fetchRow: (data: {
        site?: string;
        systemID: string;
        module: string;
        batDau?: string;
        ketThuc?: string;
        idBoPhan?: string;
        idBaoCao?: string;
        phanHe?: string;
        title?: string;
        tuNgay?: string;
        baoCaoChoKy?: string;
    }) =>
        request.post(`${baseApiMapBaoCao}/fetch-row`, data, { authorization: true } as InternalAxiosRequestConfig),
};
